import type { JobStatus } from '@muidsoft/shared';
import { IconCheck, IconHourglass, IconXCircle } from './Icons.js';

const LABELS: Record<JobStatus, string> = {
  queued: 'Antre',
  planning: 'Merencanakan',
  concepts_ready: 'Pilih konsep',
  storyboard_ready: 'Storyboard siap',
  awaiting_approval: 'Perlu disetujui',
  exporting_prompts: 'Membuat prompts',
  completed: 'Selesai',
  failed: 'Gagal',
};

function variantFor(status: JobStatus): 'success' | 'pending' | 'error' {
  if (status === 'completed') return 'success';
  if (status === 'failed') return 'error';
  return 'pending';
}

const ICON_MAP = {
  success: IconCheck,
  pending: IconHourglass,
  error: IconXCircle,
} as const;

/** StatusStamp — "cap dokumen" motif dari Tanya Dokumen, dipakai konsisten lintas produk (PRD §46.2). */
export function StatusStamp({ status }: { status: JobStatus }) {
  const variant = variantFor(status);
  const IconComponent = ICON_MAP[variant];
  return (
    <span className={`stamp stamp--${variant}`}>
      <IconComponent size={12} />
      {LABELS[status]}
    </span>
  );
}
